export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12.0003 15.5996-5.7857-5.785 1.414-1.4143 4.3717 4.3711 4.3717-4.3711 1.4141 1.4143-5.7858 5.785z" } }];
export const iconName = 'chevron-down-small';
export const chevronDownSmall = { iconName, paths };
export default paths;
